module.exports = __webpack_public_path__ + "static/img/advantage1.4baaff0d.png";